import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.common.white,
  width: '100%',
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(2),
  borderWidth: '1px',
  borderColor: (p) => p.palette.primary[100],
  borderStyle: 'solid',

  // TODO add these lines for showing on OKR
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  gap: (p) => p.spacing(0.5),
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body1,
  fontWeight: 600,
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
  color: (p) => p.palette.grey[400],
};
